import { Download, Smartphone, Mail, Printer, Lock } from "lucide-react";

const Chip = ({ children, label }) => (
  <span title={label} aria-label={label} className="flex h-8 min-w-[52px] items-center justify-center rounded-[4px] bg-white px-2">{children}</span>
);

export const PaymentBadges = ({ className = "" }) => (
  <div className={className} data-testid="payment-badges">
    <div className="flex flex-wrap items-center gap-2">
      <Chip label="Visa"><span className="font-display text-[15px] font-bold italic tracking-tight text-[#1a1f71]">VISA</span></Chip>
      <Chip label="Mastercard">
        <svg width="30" height="18" viewBox="0 0 30 18" aria-hidden="true"><circle cx="11" cy="9" r="8" fill="#eb001b" /><circle cx="19" cy="9" r="8" fill="#f79e1b" fillOpacity="0.9" /></svg>
      </Chip>
      <Chip label="PayPal"><span className="font-display text-[13px] font-bold italic"><span className="text-[#003087]">Pay</span><span className="text-[#009cde]">Pal</span></span></Chip>
      <Chip label="Klarna"><span className="rounded-[3px] bg-[#ffb3c7] px-1.5 py-0.5 font-display text-[12px] font-bold text-black">Klarna.</span></Chip>
      <Chip label="Shop Pay"><span className="font-display text-[12px] font-bold text-[#5a31f4]">Shop Pay</span></Chip>
    </div>
    <p className="mt-3 flex items-center gap-2 text-xs text-zinc-400"><Lock size={12} /> Secure, encrypted checkout powered by Shopify</p>
  </div>
);

const DELIVERY = {
  ebook: [[Download, "Instant digital download"], [Mail, "Download link by email right after payment"], [Smartphone, "Read on phone, tablet or computer"]],
  workbook: [[Download, "Instant digital download"], [Printer, "Printable PDF, 180 pages"], [Smartphone, "Fill in on paper or on screen"]],
  bundle: [[Download, "Both files as instant download"], [Smartphone, "eBook for any device"], [Printer, "Workbook as printable PDF, 180 pages"]],
};

export const DeliveryInfo = ({ role }) => (
  <ul className="grid gap-px border border-line bg-line sm:grid-cols-3" data-testid="delivery-info">
    {DELIVERY[role].map(([Icon, text]) => (
      <li key={text} className="flex items-center gap-3 bg-[#0b0b0b] px-4 py-3.5 text-xs leading-snug text-zinc-200 sm:flex-col sm:items-start sm:gap-2">
        <Icon size={16} className="shrink-0 text-white" />{text}
      </li>
    ))}
  </ul>
);
